import moment from 'moment';
import calculateValorTotal from '../../../modulos/calcPrime';
import { somaTotalDependentes } from '../../../modulos/function/somaTotalDependentes';

export const tipoCobrancaEnum = {
    boleto: 'Boleto',
    cartao: 'Cartão(Recorrente)'
};

export const formatTipoCobranca = tipoCobranca => {
    switch (tipoCobranca) {
        case 7:
            return tipoCobrancaEnum.cartao;

        default:
            return tipoCobrancaEnum.boleto;
    }
};

const categoriasPet = ['ZPE26', 'ZPEAD', 'ZPET', 'ZPETA', 'ZPETL'];

export const existePetNoPlano = dependentes => {
    const existePet = dependentes.find(dep => categoriasPet.includes(dep.categoria));

    if (existePet) {
        return 'Sim';
    }

    return 'Não';
};

export const enumStatusAceite = {
    pendente: 'PENDENTE',
    enviado: 'ENVIADO',
    migrado: 'MIGRADO',
    recusado: 'RECUSADO'
};

export const statusEnvioAceite =
    [{ label: 'PENDENTE' }, { label: 'ENVIADO' }, { label: 'ACEITO' }, { label: 'RECUSADO' }];

export const validarTipoAceite = infoAceite => {
    const tipoAceite = {
        PENDENTE: 0,
        ENVIADO: 1,
        MIGRADO: 2,
        RECUSADO: 3
    };

    return tipoAceite[infoAceite];
};

export const somaTotalPlanoMaisDepententes = dadosPlanoDestino => {
    const { destino: { plano, associado, dependentes } } = dadosPlanoDestino;
    const { SubGrupo: subGrupo, ValorBase } = plano;

    const arrayDependentes = dependentes.map(dependente => ({
        ...dependente,
        'CategoriaParentesco.Valor': dependente.valor,
        'Associado.Plano': subGrupo
    }));
    const totalDependentes = somaTotalDependentes(arrayDependentes);

    associado.SubGrupo = subGrupo;
    associado['ProdutosPreco.valorBase'] = ValorBase;

    const resultSoma = calculateValorTotal(associado, totalDependentes, 0);

    dadosPlanoDestino.destino.plano.valorMensalTotal = resultSoma.valorTotal;

    return resultSoma.valorTotal;
};

export const formatarData = data => {
    const dataValida = moment(data).format('DD/MM/YYYY');

    if (dataValida !== 'Invalid date') {
        return dataValida;
    }

    return data;
};
